import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import { ContactCtaSection, FaqSection, PageHero } from "../components/JalRoSections";

const FaqPage = () => (
  <JalRoLayout>
    <PageHero
      title="Frequently Asked Questions"
      text="Answers for RO repair, installation, AMC, spare parts, service areas and enquiry support."
      image="/assets/img/jal-ro/palak-slide-4.jpg"
    />
    <FaqSection />
    <ContactCtaSection />
  </JalRoLayout>
);

export default FaqPage;
